import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AdminHeader } from '@/components/layout/admin/AdminHeader';
import { AdminChatArea } from '@/components/chat/admin/AdminChatArea';
import { AdminSettingsPanel } from '@/components/layout/admin/AdminSettingsPanel';
import { ReconnectOverlay } from '@/components/overlay/ReconnectOverlay';
import { useAppStore } from '@/hooks/useAppStore';
import { TextInput } from '@/components/layout/TextInput';

export const AdminPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const routeRoomId = searchParams.get('r') // Get room ID from URL
  const [showSettings, setShowSettings] = useState(true);

  // Select necessary state and actions from Zustand store
  const inspectRoom = useAppStore((state) => state.inspectRoom);
  const isConnected = useAppStore((state) => state.isConnected);
  const isConnecting = useAppStore((state) => state.isConnecting);
  const isReconnecting = useAppStore((state) => state.isReconnecting);
  const clientConfig = useAppStore((state) => state.clientConfig);
  const connectedUsers = useAppStore((state) => state.connectedUsers);

  // Map clientConfig.fontSize to ChatArea textSize
  const fontSize = clientConfig?.fontSize || "normal";
  const fontSizeToTextSize: Record<string, "base" | "lg" | "xl" | "2xl" | "4xl"> = {
    normal: "base",
    large: "2xl",
    xlarge: "4xl",
  };
  const textSize = fontSizeToTextSize[fontSize] || "base";

  // Effect to handle connection based on URL parameter
  useEffect(() => {
    const { isConnected, isConnecting, isReconnecting } = useAppStore.getState();

    if (isConnected || isConnecting || isReconnecting) {
      return;
    }

    if (routeRoomId) {
      inspectRoom(routeRoomId);
    }
  }, [isConnected, isConnecting, isReconnecting, routeRoomId, inspectRoom]);

  return (
    <div className="relative flex flex-col w-full border border-chotto-border shadow-xl overflow-hidden h-full rounded-lg">
      <AdminHeader showSettings={showSettings} onToggleSettings={() => setShowSettings(!showSettings)} />
      <div className="chat-body relative flex flex-1 min-h-0 overflow-hidden">
        <div className="flex flex-col flex-1 min-w-0">
          <AdminChatArea textSize={textSize} roomId={routeRoomId || ""} />
          <div className="relative flex-shrink-0 p-2 border-t border-neutral-500/30">
            <div className="flex items-center justify-center space-x-4">
              <div className="w-full ml-8">
                <TextInput isAdmin={true} userList={connectedUsers} />
              </div>
            </div>
          </div>
        </div>
        {showSettings && <AdminSettingsPanel />}
      </div>
      {isReconnecting && <ReconnectOverlay />}
    </div>
  );
};

export default AdminPage;
